var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-wrapper"},[_c('div',{staticStyle:{"height":"96%"},attrs:{"id":_vm.editorId}})])}
var staticRenderFns = []

export { render, staticRenderFns }